import { Box, useTheme, Typography } from "@mui/material";
import { tokens } from "../../theme";

import { useParams } from 'react-router-dom';
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectSellers } from "../../store/sellers/sellers.selector";

import { Grid } from '@mui/material';
import { IconButton } from "@mui/material";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";


import InforSectionSeller from "./info-section";
import DataSectionSeller from "./data-section";


const SellerPage = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const { slug } = useParams(); // Access the slug (seller name)
    // const location = useLocation();



    const sellersData = useSelector(selectSellers)
    const [seller, setSeller] = useState(null);
    const [isLoadingKit, setIsLoadingKit] = useState(false);

    const openBar = '260px'
    const closedBar = '120px'

    const [isOpen, setIsOpen] = useState(true);
    const sidebarWidth = isOpen ? openBar : closedBar;

    useEffect(() => {
        // console.log('slug: ', slug)
        // Find the seller that matches the slug
        const foundSeller = sellersData.find(seller => seller.slug === slug);
        // console.log('foundSellers: ', foundSeller)
        // console.log('sellersData: ', sellersData)

        if (foundSeller) {
            setSeller(foundSeller); // Set the found seller
        } else {
            // Handle case where seller is not found (optional: redirect or show an error)
            setSeller(undefined);
        }
    }, [slug]);

    if (!seller && !isLoadingKit) {
        return (

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    // alignItems: 'center',
                    height: "100%",
                    paddingTop: "50px",
                }}
            >
                <Typography variant="h2" color={colors.yellow[400]} sx={{ paddingTop: '20px', paddingLeft: '20px' }}>
                    Vendedora não encontrada ou não carregada...
                </Typography>
            </Box>
        )
    }


    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                // alignItems: 'center',
                height: "100%",
                paddingTop: "60px",
                position: 'absolute',
                width: '100%'
            }}
        >


            <Grid container spacing={2} sx={{ height: "100%", width: "100%", display: "flex" }}>
                {/* Lateral fixa */}
                <Grid item
                    sx={{
                        overflowY: 'auto',
                        borderRight: "1px solid whitesmoke",
                        flex: 1,
                        position: "fixed",
                        width: sidebarWidth, // Dynamic width
                        overflow: "auto",
                        paddingBottom: "20px",
                        backgroundColor: "rgba(255, 255, 255, 0.0)", // Semi-transparent white
                        backdropFilter: "blur(10px)", // Blur effect
                        boxShadow: "4px 0px 10px rgba(0, 0, 0, 0.1)", // Soft shadow    
                        zIndex: 10, // Ensures it's above the content
                        transition: "width 0.3s ease-in-out" // Smooth transition
                    }}
                >
                    {/* Toggle Button */}
                    <IconButton onClick={() => setIsOpen(!isOpen)} sx={{ position: "absolute", top: 10, right: isOpen ? 10 : 0, zIndex: 999 }}>
                        {isOpen ? <ArrowBackIcon /> : <ArrowForwardIcon />}
                    </IconButton>

                    <InforSectionSeller seller={seller} isOpen={isOpen} />
                </Grid>

                {/* Conteúdo ajustado corretamente */}
                <Grid item
                    sx={{
                        flex: 1,
                        padding: "0px 10px",
                        marginLeft: sidebarWidth, // Adjust dynamically
                        paddingBottom: "50px",
                        width: `calc(100% - ${sidebarWidth})`, // Avoid shifting
                        minWidth: '1400px',
                        overflowX: "auto", // Allow horizontal scrolling only to the right
                        transition: "margin-left 0.3s ease-in-out, width 0.3s ease-in-out", // Smooth content shift
                        // transform: "scale(0.9)", // 👈 Adjust scale factor (0.9 = 90% zoom)
                        transformOrigin: "top left", // 👈 Ensures scaling starts from top left
                        // width: "111%", // 👈 Increase width to prevent content from shrinking
                        // height: "111%", // 👈 Optional, adjust if needed
                        // 👇 Apply fontSize to all child elements
                        '& *': {
                            fontSize: '12px', // or whatever size you want
                        },
                    }}
                >
                    <DataSectionSeller
                        seller={seller}
                        isLoadingKit={isLoadingKit}
                        setIsLoadingKit={setIsLoadingKit}
                    />
                </Grid>
            </Grid>
        </Box>
    );
}

export default SellerPage;